import { type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyStateAction {
  label: string;
  icon: LucideIcon;
  onClick: () => void;
  variant?: "default" | "outline";
  disabled?: boolean;
}

interface ProductSectionEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actions?: EmptyStateAction[];
}

export function ProductSectionEmptyState({
  // AUT-196 (design QA 2026-10-14): "we removed the box icon from our no data states". Still
  // accepted so the four call sites need no edit.
  icon: _icon,
  title,
  description,
  actions = [],
}: ProductSectionEmptyStateProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center py-16 px-6 text-center rounded-sm border border-border w-full">
      <h2 className="text-base font-semibold text-foreground mb-2">{title}</h2>
      <p className="text-sm text-muted-foreground mb-6 max-w-md">{description}</p>
      {actions.length > 0 && (
        <div className="flex flex-wrap items-center justify-center gap-2">
          {actions.map((action) => (
            <Button
              key={action.label}
              type="button"
              variant={action.variant ?? "secondary"}
              size="sm"
              className="gap-1.5"
              disabled={action.disabled}
              onClick={action.onClick}
            >
              <action.icon className="h-4 w-4" />
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
